import React from "react";
import BoxCompanies from "../../../shared/create-offer/BoxCompanies/BoxCompanies";
import Loading from "../../../shared/create-offer/Loading/Loading";
import { css } from "emotion";
import Input from "../../../shared/AtomicInput";

import {
	pageFidelityPrograms,
	loadingStyle,
	pageFidelityProgramsFlex,
	pageFidelityProgramsSearch,
	pageFidelityProgramsSearchInput
} from "./style";

const FidelityProgram = props => {
	return props.loading ? (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	) : (
		<div
			className={css`
				${pageFidelityProgramsFlex};
			`}
		>
			<div
				className={css`
					${pageFidelityProgramsSearch};
				`}
			>
				<p>Para fazer sua oferta, selecione o programa de fidelidade onde estão suas milhas:</p>
				<div
					className={css`
						${pageFidelityProgramsSearchInput};
					`}
				>
					<Input
						name="search"
						id="search"
						type="text"
						placeholder="Pesquisar programa"
						onChange={ev => props.filterCompanies(ev.target.value)}
						icon="icon-search"
						data-action="fidelity-programs-search"
					/>
				</div>
			</div>
			<div
				className={css`
					${pageFidelityPrograms};
				`}
			>
				<BoxCompanies
					companies={props.companies}
					typePhoneLatam={props.typePhoneLatam}
					onClick={obj => props.onChange(obj)}
				/>
			</div>
		</div>
	);
};

export default FidelityProgram;
